<template>
	<div v-show="visible" class="custom-dialog">
		<div style="width: 100%;display: flex;justify-content: center">
			<transition name="dialog-fade">
				<div v-if="visible" class="box" style="display: flex;flex-direction: column;align-items: center;justify-content: center">
					<div class="title">
						<span style="font-size: 18rem;color: #1E3AA2;font-weight: 600">全部信息</span>
						<i class="el-icon-close" @click="onClosed"></i>
					</div>

					<el-timeline style="padding: 24rem">
            <el-timeline-item color="#AAC4FF">
              <div class="l-title">个人信息</div>
              <div class="l-content">
                <div class="l-list">
                  <div class="l-item" v-for="(item, idx) in list1" :key="idx">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ allInfo.base[item.value] }}</div>
                  </div>
                </div>
                <div class="l-info">
                  <div class="item">
                    <div class="label">是否有过敏体质</div>
                    <div class="value">{{ allInfo.all.allergy }}</div>
                  </div>
                  <div v-if="allInfo.all.allergy === '有'" class="content">
                    <span class="tips">注：</span>
                    <span>{{ allInfo.all.allergy_details }}</span>
                  </div>
                  <div class="item">
                    <div class="label">是否有重大疾病</div>
                    <div class="value">{{ allInfo.all.serious_ill }}</div>
                  </div>
                  <div v-if="allInfo.all.serious_ill === '有'" class="content">
                    <span class="tips">注：</span>
                    <span>{{ allInfo.all.serious_ill_details }}</span>
                  </div>
                  <div class="item">
                    <div class="label">是否有心理障碍</div>
                    <div class="value">{{ allInfo.all.psychological_disorders }}</div>
                  </div>
                  <div v-if="allInfo.all.psychological_disorders === '有'" class="content">
                    <span class="tips">注：</span>
                    <span>{{ allInfo.all.psychological_disorders_details }}</span>
                  </div>
                </div>
              </div>
            </el-timeline-item>
            <el-timeline-item color="#AAC4FF">
              <div class="l-title">家庭信息</div>
              <div class="l-content">
                <div class="l-list">
                  <div class="l-item" v-for="(item, idx) in list2" :key="idx">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ allInfo.family[item.value] }}</div>
                  </div>
                  <div class="l-item full">
                    <div class="label">家庭情况</div>
                    <div class="value">
                      <div class="content-info">
                        {{ allInfo.all.home_details }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-timeline-item>
            <el-timeline-item color="#AAC4FF">
              <div class="l-title">初中学习概况</div>
              <div class="l-content">
                <div class="l-list">
                  <div class="l-item" v-for="(item, idx) in list3" :key="idx">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ allInfo.all[item.value] }}</div>
                  </div>
                </div>
                <div class="content-subject">
                  <span v-if="!allInfo.all.senior_score_subject.length">-</span>
                  <template v-else>
                    <div class="item" v-for="i in allInfo.all.senior_score_subject">
                      <div>{{ i.subject_name }}</div>
                      <div>{{ i.subject_entrance }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </el-timeline-item>
            <el-timeline-item color="#AAC4FF">
              <div class="l-title">在校信息</div>
              <div class="l-content">
                <div class="l-list">
                  <div class="l-item" v-for="(item, idx) in list4" :key="idx">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ allInfo.base[item.value] }}</div>
                  </div>
                </div>
              </div>
            </el-timeline-item>
					</el-timeline>
				</div>
			</transition>
		</div>

	</div>
</template>

<script>
export default {
	name: "l-dialog",
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		allInfo: {},
	},
	data() {
		return {
      list1: [
        { label: "姓名", value: "student_name" },
        { label: "出生日期", value: "birthday" },
        { label: "性别", value: "student_gender" },
        { label: "民族", value: "nation_name" }
      ],
      list2: [
        { label: "监护人姓名", value: "name" },
        { label: "与学生的关系", value: "relationship_name" },
        { label: "监护人电话", value: "phone" },
        { label: "是否为独生子女", value: "only_child" },
        { label: "父亲职业", value: "father_job" },
        { label: "母亲职业", value: "mother_job" },
        { label: "家庭地址", value: "home_address" },
        { label: "是否出国经历", value: "is_chuguo" }
      ],
      list3: [
        { label: "初中毕业学校", value: "student_attend_graduation_school" },
        { label: "中考所在区域", value: "senior_region" },
        { label: "初中是否留级", value: "student_attend_repetition" },
        { label: "初中是否休学", value: "student_attend_suspend" }
      ],
      list4: [
        { label: "学号", value: "student_no" },
        { label: "宿舍", value: "dormitory" },
        { label: "校区", value: "school_name" },
        { label: "年级", value: "grade_name" },
        { label: "行政班", value: "class_name" },
        { label: "班主任", value: "teacher_name" },
        { label: "学习方向", value: "learning_direction" },
        { label: "专业方向", value: "major" },
        { label: "政治面貌", value: "political_outlook" },
        { label: "学籍所在地", value: "student_address" }
      ]
		};
	},
	methods: {
		onClosed() {
			this.$emit("update:visible", false);
			this.$emit("closed");
		},
	},

};
</script>

<style lang="scss" scoped>
.l-title {
  margin-bottom: 16rem;
  font-size: 14rem;
  color: #3C3C3C;
  font-weight: bold;
}
.l-content {
  margin-bottom: 4rem;
  padding: 24rem;
  background-color: #F6F9FF;
  border-radius: 4rem;
}
.l-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16rem;
  // &.l1 {
  //   grid-template-columns: calc(40% - 8rem) calc(60% - 8rem);
  // }
}
.l-item {
  display: flex;
  font-size: 14rem;
  &.full {
    grid-column: 1 / -1;
  }
  .label {
    min-width: 110rem;
    height: 18rem;
    color: #888;
    flex-shrink: 0;
  }
  .value {
    color: #3C3C3C;
  }
}
.l-info {
  padding-top: 16rem;
  .item {
    padding-bottom: 10rem;
    font-size: 14rem;
    color: #888;
    display: flex;
    .label {
      width: 110rem;
      flex-shrink: 0;
    }
    .value {
      color: #3C3C3C;
    }
  }
  .content {
    padding: 8rem;
    margin-bottom: 20rem;
    color: #666;
    font-size: 11rem;
    background-color: #FFF9EB;
    .tips {
      color: #F6AD3C;
    }
  }
}
.content-info {
  padding: 8rem;
  color: #666;
  font-size: 11rem;
  background: #fff;
  border-radius: 4rem;
}
.content-subject {
  height: 62rem;
  background: #fff;
  border-radius: 4rem;
  margin-top: 20rem;
  padding: 10rem 24rem;
  font-size: 12rem;
  color: #3C3C3C;
  display: flex;
  justify-content: space-between;
  .item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 4rem;
    align-items: center;
  }
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
	transition: all 0.3s ease;
}

.dialog-fade-enter-to,
.dialog-fade-leave-to {
	opacity: 0;
	transform: translateY(-20rem);
}

.custom-dialog {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 105rem 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.4);
	z-index: 9999999;
	overflow-y: auto;
}

.box {
	width: 720rem;
	min-height: 1160rem;
	background: #FFFFFF;
	border-radius: 8rem;

	.title {
		width: 720rem;
		height: 50rem;
		border-bottom: 1rem solid #F6F9FF;
		padding: 0 24rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}

::v-deep .el-timeline-item__tail {
	border-left: 2rem dashed #D8D8D8;
}

// .el-timeline-item:last-of-type {
// 	display: none;
// }
</style>
